
export const BG_ENDPOINTS = {
    Endpoint: `${process.env["REACT_APP_BREAKGLASS_API"]}`,
    Resources : ['request/mine', 'review/pending', 'review/processed', 'audit/requests', 'request/create', 'request/delete', 'review/approve', 'review/reject', 'federate/console', 'federate/cli']
};